export const CATALOG_FORM_ROUTE = '/catalog-form';

export const CATALOG_FORM_TEXTS = {
  BACK_BUTTON: 'Back',
  DETAILS_HEADING: 'Description',
  LOADING_MESSAGE: 'Loading your request form…',
  ERROR_TITLE_NOT_ENTITLED: 'You cannot submit this request',
  READY_TITLE: 'Fulfill your request',
  DEFAULT_ERROR_MESSAGE: 'Something went wrong while loading this request form.',
  RETRY_BUTTON: 'Try again',
  SUBMITTED_TITLE: 'Request submitted',
  SUBMITTED_FALLBACK_MESSAGE: 'Your request has been submitted.',
  SUBMITTED_REFERENCE_LABEL: 'Reference number:',
  SUBMIT_ANOTHER_BUTTON: 'Submit another',
  SUBMITTING: 'Submitting…',
  SUBMIT_ERROR_FALLBACK: 'We could not submit your request. Please try again later.',
  SUBMIT_BLOCKED:
    "This request can't be submitted yet: a check on this form did not pass. Review your entries and try again.",
  DYNAMIC_VALUES_UNAVAILABLE:
    'Some values on this form are calculated automatically, and that calculation is temporarily unavailable ' +
    'while a ServiceNow admin approves it. You can still fill in and submit the form.',
  REQUIRED_FIELD_ERROR: 'This field is required.',
  REQUIRED_CHOICE_ERROR: 'Please choose an option.',
  REQUIRED_SR: '(required)',
  REQUIRED_MULTI_ERROR: 'Please add at least one entry.',
  // r2f 1.1.3 §6: advanced / dynamic reference qualifiers fail closed.
  REFERENCE_NO_OPTIONS: 'No options available for this field.',
  REFERENCE_LOOKUP_ERROR: "We couldn't load the options for this field. Please try again later.",
  // r2f 1.1.3 §3: metadata `item.noOrder`.
  NO_ORDER: 'This item cannot be ordered from here.',
  SHOW_VALUE: 'Show value',
  HIDE_VALUE: 'Hide value',
  MORE_INFO_SR: 'More information',
  LICENSE_COST_LABEL: 'License cost responsibility:',
  SERVICE_BOOK_LINK: 'Open Service Book information',
  NEW_TAB_SR: '(opens in a new tab)',
  // Same wording as the RoSE portal's catalog submit notice.
  SENSITIVE_DATA_DISCLAIMER:
    'When submitting a ticket, please do not enter - or attach documents with - sensitive personal data. ' +
    'This includes but is not limited to: medical / health status or information, social security or tax ' +
    'identifying numbers, credit card numbers, political opinions, religious beliefs, or any other data ' +
    'considered sensitive in your country. If in doubt on what constitutes sensitive personal data, please ' +
    'reach out to your local Data Privacy Officer. While we strive to ensure security and privacy, sharing ' +
    'such information in tickets could result in unintended exposure and potential risks.',
};

// INEXP-2383: mirrors the RoSE catalog item widget — 25 MB per file
// (`maxAttachmentSize`), no file-type restriction, same wording. Required only
// when the item has `mandatoryAttachment`.
export const CATALOG_ATTACHMENT_LIMITS = {
  MAX_FILE_SIZE_MB: 25,
};

export const CATALOG_ATTACHMENT_TEXTS = {
  LABEL: 'Add attachments',
  REMOVE_FILE: 'Remove file',
  REMOVE_FILE_NAMED: (name: string) => `Remove ${name}`,
  CHOOSE_FILE: 'Choose a file',
  OR_DRAG_IT_HERE: 'or drag it here.',
  LIST_LABEL: 'Attached files',
  FILES_ADDED: (names: string[]) => `Added ${names.join(', ')}`,
  FILE_REMOVED: (name: string) => `Removed ${name}`,
  REQUIRED_SR: '(required)',
  REQUIRED_ERROR: 'You must attach a file to submit the request',
  READ_ERROR: 'One of your attachments could not be read. Add the files again and resubmit.',
  FILE_TOO_LARGE: (name: string) =>
    `${name}: The size of the attached file must be smaller than ${CATALOG_ATTACHMENT_LIMITS.MAX_FILE_SIZE_MB} MB`,
};
